// extracted by mini-css-extract-plugin
module.exports = {"search":"search___1fk_B","headerSearch":"header-search___2mv5D","container":"container___3suDt","close":"close___1AImy"};